module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "home-page"
    }
  }, [(!_vm.shouldShowLandingPage && !_vm.failedLogin) ? _c('div', {
    attrs: {
      "id": "validating-login"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.shouldShowLandingPage || _vm.failedLogin) ? [_c('div', {
    attrs: {
      "id": "headline"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "login-container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleLoginForm($event)
      }
    }
  }, [(!_vm.showLoginForm) ? [_vm._v("Login")] : [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Return")]], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "upsell"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.showLoginForm) ? [_c('login-form')] : _c('div', {
    attrs: {
      "id": "pitch-container"
    }
  }, [_c('div', {
    staticClass: "pitch"
  }, [_c('div', {
    staticClass: "description"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _vm._v(" Free Video Chat")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v(" Make New Friends")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" No Download")]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" 100% Free!")])]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [_c('img', {
    attrs: {
      "src": "/static/landing-page-preview-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "registration"
  }, [_c('register-form')], 1)])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ad-container"
    }
  }, [_c('ad-container', {
    attrs: {
      "ad-slot": "2462240339"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.showLoginForm) ? [_c('h1', {
    attrs: {
      "id": "feature-header"
    }
  }, [_vm._v("Features")]), _vm._v(" "), _vm._m(2)] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading large"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" "), _c('p', [_vm._v("Validating Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("1 on 1 Video Calls")]), _vm._v(" "), _c('p', [_vm._v("HD Video Chat with friends, family, and strangers completely free from your web browser. No download required to make it work!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Group Video Calls")]), _vm._v(" "), _c('p', [_vm._v("HD Video Chat with a whole group! Video Conferencing is free, easy to set up, and fun!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Share Gifs")]), _vm._v(" "), _c('p', [_vm._v("Chat has never been more fun with the ability to easily search and send animated Gifs right into the chatroom!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Meet New People")]), _vm._v(" "), _c('p', [_vm._v("With public chatrooms, group chats, and private chats, you can chat how ever you want to! Make friends that will last a life time. Video Chatting strangers is fun and safe!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Share Files")]), _vm._v(" "), _c('p', [_vm._v("Upload and send files to your friends and group chats easily with the click of a button. On mobile, you can even send a live camera picture.")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("User Profiles")]), _vm._v(" "), _c('p', [_vm._v("Express yourself on your Profile with a Bio and up to ten photos. Browse other members profiles to find new friends, look at photos, and read bios.")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Cross-Platform")]), _vm._v(" "), _c('p', [_vm._v("Mixsii works on all browsers and mobile devices! It looks good on Desktop, Tablet, and Mobile. Video Chat also works on all platforms!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Themes")]), _vm._v(" "), _c('p', [_vm._v("Customize the way your chat panel looks by selecting your own color pallet!")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h1', [_vm._v("Markdown Text Messages")]), _vm._v(" "), _c('p', [_vm._v("All Chat Messages support the Markdown Language, allowing you to easily format text posts with bold and italic words.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c0e31a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/HomePage/HomePage.vue
// module id = 384
// module chunks = 1